import {
	HOME_ANIMATE,
	SET_HOME_SHOW_VIDEO
} from '../actions/Types';

const INITIAL_STATE = {
	animate: false,
	showVideo: null
}

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case HOME_ANIMATE:
			return { ...state, animate: action.payload };
		case SET_HOME_SHOW_VIDEO:
			return {...state, showVideo: action.payload}
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/HomeReducer.js